'use strict';/* global define */define('modules/users/services/me/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
service.$inject = ["MeFactory"];
function service(MeFactory){// jshint validthis:true
// jshint latedef:false
var me;var succeeded=false;this.get=get;// ---
function get(){if(!succeeded){me=MeFactory.get();me.$promise.then(success);}return me;}function success(){succeeded=true;}}module.exports=service;});
